import { func, object, string } from 'prop-types';
import React from 'react';
const SingleItem = ({ clauseClassName, clause, onClickClauseSection }) => {
    SingleItem.propTypes = {
        clauseClassName: string,
        clause: object.isRequired,
        onClickClauseSection: func.isRequired,
    };
    return (React.createElement("div", { className: clauseClassName, onClick: onClickClauseSection }, clause.displayName));
};
export default SingleItem;
